export default function Image({ src, width, height, alt, ...rest }) {
    return (
        <img
            className="image"
            src={src}
            width={width}
            height={height}
            alt={alt}
            {...rest}
        />
    )
}
